import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiAlertCircle } from "react-icons/fi";
import { useDashboardQuery } from "../../../../store/admin/dashboard/dashboardSlice";
import { Pill, ProgressBar, SectionCard } from "../../../../components/Dashboard";
import { summariseChecklist } from "./staffHomeModel";

const resolveChecklistLink = (title, link) => {
  const normalizedTitle = String(title || "").toLowerCase();

  // Setup checklist should open bank account list, not create page.
  if (
    normalizedTitle.includes("society bank accounts") ||
    normalizedTitle.includes("society bank info")
  ) {
    return "/super_admin/settings/society_bank_info";
  }

  return link;
};

const SetupItem = ({ title, link, navigate }) => (
  <div className="dx-row" style={{ minHeight: 48 }}>
    <span className="dx-row-icon dx-row-icon--warn">
      <FiAlertCircle aria-hidden="true" size={16} />
    </span>
    <span className="dx-row-main">
      <span className="dx-row-title" style={{ fontSize: 14 }}>
        {title}
      </span>
    </span>
    <button
      type="button"
      className="dx-link"
      style={{ background: "none", border: 0, padding: 0, cursor: "pointer", font: "inherit", fontWeight: 600 }}
      onClick={() => navigate(resolveChecklistLink(title, link))}
    >
      Configure
    </button>
  </div>
);

/** Set-up steps that are still open. Hidden once everything is done. */
export default function SetupChecklist() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedPeriod = searchParams.get("mode") ?? "Weekly";
  const selectedYear = searchParams.get("year") ?? new Date().getFullYear().toString();

  const { data, isFetching } = useDashboardQuery({
    weekly: selectedPeriod === "Weekly",
    year: selectedYear,
  });

  const checklist = data?.data?.setupChecklist;

  // Don't show if data is still fetching
  if (isFetching && !data) return null;

  const summary = summariseChecklist(checklist);
  // Nothing to show when there are no steps, or they are all done
  if (summary.total === 0 || summary.complete || Number(checklist?.progress) >= 100) {
    return null;
  }

  return (
    <div data-tour="tour-setup-checklist">
      <SectionCard
        title="Set-up checklist"
        action={
          <Pill tone="warn">
            {summary.done} of {summary.total} done
          </Pill>
        }
      >
        <ProgressBar value={summary.progress} label="Set-up progress" />
        <div className="dx-list">
          {summary.open.map((item, index) => (
            <SetupItem key={`${item.title}-${index}`} title={item.title} link={item.link} navigate={navigate} />
          ))}
        </div>
      </SectionCard>
    </div>
  );
}
